namespace GeniuzPOS.PosShift {
    export namespace PermissionKeys {
        export const Report = "";

        namespace ReportSaleTax {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E27\u0E31\u0E19\u0E02\u0E32\u0E22:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E20\u0E32\u0E29\u0E35\u0E02\u0E32\u0E22:View";
        }

        namespace CashierRecv {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E27\u0E31\u0E19\u0E02\u0E32\u0E22:\u0E2A\u0E23\u0E38\u0E1B\u0E01\u0E32\u0E23\u0E23\u0E31\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E41\u0E04\u0E0A\u0E40\u0E0A\u0E35\u0E22\u0E23\u0E4C:View";
        }

        namespace TaxInvoince {
            export const Modify = "1POSBASE:\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35:\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35:Modify";
            export const View = "1POSBASE:\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35:\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35:View";
        }

        namespace VatRefund {
            export const Modify = "1POSBASE:\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35:VatRefund:Modify";
            export const View = "1POSBASE:\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35:VatRefund:View";
        }

        namespace VatRefundconfig {
            export const Modify = "1POSBASE:\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35:\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E01\u0E23\u0E30\u0E14\u0E32\u0E29\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C:Modify";
            export const View = "1POSBASE:\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35:\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E01\u0E23\u0E30\u0E14\u0E32\u0E29\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C:View";
        }
    }
}
